"use client"

/**
 * "Add questions" block for the profile menu: the switch between the two
 * versions of the journey (`use-add-questions-journey`).
 *
 * Same placement argument as `QuestionSearchModeMenu`. The two versions are
 * being compared, so the switch has to sit somewhere neither of them owns,
 * and the focus shell's header is already carrying the way back, the title,
 * and Done.
 */

import {
  DropdownMenuRadioGroup,
  DropdownMenuRadioItem,
  DropdownMenuSub,
  DropdownMenuSubContent,
  DropdownMenuSubTrigger,
} from "@/components/ui/dropdown-menu"
import {
  ADD_QUESTIONS_JOURNEYS,
  setAddQuestionsJourney,
  useAddQuestionsJourney,
  type AddQuestionsJourney,
} from "@/hooks/use-add-questions-journey"

export function AddQuestionsJourneyMenu() {
  const journey = useAddQuestionsJourney()
  const active = ADD_QUESTIONS_JOURNEYS.find((option) => option.id === journey)

  return (
    <DropdownMenuSub>
      <DropdownMenuSubTrigger>
        <i className="fa-light fa-layer-group" aria-hidden="true" />
        Add questions
        <span className="ms-auto pe-1 text-xs text-muted-foreground">
          {active?.label}
        </span>
      </DropdownMenuSubTrigger>
      {/* No `DropdownMenuPortal`: portalled sub-content lands under the
          dismissable layer and stops taking clicks. */}
      <DropdownMenuSubContent className="w-72">
        <DropdownMenuRadioGroup
          value={journey}
          onValueChange={(value) =>
            setAddQuestionsJourney(value as AddQuestionsJourney)
          }
        >
          {ADD_QUESTIONS_JOURNEYS.map((option) => (
            <DropdownMenuRadioItem
              key={option.id}
              value={option.id}
              className="items-start gap-2 py-2"
            >
              <span className="flex flex-col gap-0.5">
                <span className="font-medium">{option.label}</span>
                <span className="text-xs leading-snug text-muted-foreground">
                  {option.description}
                </span>
              </span>
            </DropdownMenuRadioItem>
          ))}
        </DropdownMenuRadioGroup>
      </DropdownMenuSubContent>
    </DropdownMenuSub>
  )
}
